module.exports = __webpack_public_path__ + "static/media/evothings.92a6e6c6.png";